// Per-type wiring for the DSE mobile quote app (EV / Petrol / Finance).
const emiBlock = (emi) =>
  emi.enabled && emi.scheme_id
    ? { enabled: true, scheme_id: emi.scheme_id, down_payment: emi.down_payment !== "" ? Number(emi.down_payment) : null }
    : { enabled: false };

export const QUOTE_TYPES = {
  ev: {
    label: "EV",
    sub: "iQube / Orbiter",
    pricelist: "/ev-pricing/quotes/pricelist",
    base: "/ev-pricing/quotes",
    options: [
      { key: "is_financed", label: "On finance" },
      { key: "ext_warranty", label: "2Y extended warranty" },
    ],
    defaults: { is_financed: false, ext_warranty: false },
    emiOptional: true,
    payload: (row, opts, customer, emi) => ({
      customer,
      vehicle_ref_id: row.id,
      vehicle_model: row.package_name,
      finance: { is_financed: opts.is_financed || emi.enabled, financier: "", extended_warranty_2y: opts.ext_warranty },
      finance_quote: emiBlock(emi),
    }),
    total: (q) => q.totals?.net_total,
    emi: (q) => q.finance_quote?.computed,
  },
  ice: {
    label: "Petrol",
    sub: "ICE scooters & bikes",
    pricelist: "/pricing/quotes/pricelist",
    base: "/pricing/quotes",
    options: [
      { key: "is_financed", label: "On finance" },
      { key: "helmet_yes", label: "Helmet" },
      { key: "full_acc_yes", label: "Full accessories" },
      { key: "ext_warranty_5y_yes", label: "5Y extended warranty" },
    ],
    defaults: { is_financed: false, helmet_yes: true, full_acc_yes: true, ext_warranty_5y_yes: true },
    emiOptional: true,
    payload: (row, opts, customer, emi) => ({
      customer,
      vehicle_ref_id: row.id,
      vehicle_model: row.package_name,
      flags: { ...opts, is_financed: opts.is_financed || emi.enabled, financier: "" },
      finance: emiBlock(emi),
    }),
    total: (q) => q.totals?.net_total,
    emi: (q) => (q.finance?.enabled ? q.finance.computed : null),
  },
  finance: {
    label: "Finance",
    sub: "EMI quote",
    pricelist: "/pricing/quotes/pricelist",
    base: "/finance/quotes",
    options: [
      { key: "hypothecation", label: "Hypothecation ₹500" },
      { key: "ext_warranty", label: "5Y extended warranty ₹999" },
    ],
    defaults: { hypothecation: true, ext_warranty: true },
    emiOptional: false,
    payload: (row, opts, customer, emi) => ({
      customer,
      vehicle_ref_id: row.id,
      vehicle_model: row.package_name,
      vehicle_price: row.dealer_price,
      hypothecation: opts.hypothecation ? 500 : 0,
      ext_warranty: opts.ext_warranty ? 999 : 0,
      scheme_id: emi.scheme_id,
      down_payment: emi.down_payment !== "" ? Number(emi.down_payment) : null,
    }),
    total: (q) => q.computed?.amount,
    emi: (q) => q.computed,
  },
};

export const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
